/**
 * Helpers for rendering the dynamic activations menu-validation fields (ITRTL-720).
 *
 * The constant data (labels, ordering) lives in `enums.js`; this module holds the small bits of
 * behaviour that derive display values from it, so `enums.js` stays a pure constants file.
 */

import { ACTIVATIONS_VALIDATION_LABELS, ACTIVATIONS_VALIDATION_ORDER } from "./enums";

/**
 * Humanise an unknown validation-type key, e.g. "someNewRule" -> "Some New Rule".
 */
export const humanizeValidationType = (type) => {
  if (!type) return "";
  return type
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/[_-]+/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase())
    .trim();
};

/**
 * Resolve a display label for a validation type, falling back to a humanised key.
 */
export const getValidationLabel = (type) =>
  ACTIVATIONS_VALIDATION_LABELS[type] || humanizeValidationType(type);

/**
 * Order a list of applicable validation types by ACTIVATIONS_VALIDATION_ORDER,
 * appending any unknown types (in their original order) at the end.
 */
export const orderValidationTypes = (types) => {
  if (!Array.isArray(types)) return [];
  const known = ACTIVATIONS_VALIDATION_ORDER.filter((t) => types.includes(t));
  const extras = types.filter((t) => !ACTIVATIONS_VALIDATION_ORDER.includes(t));
  return [...known, ...extras];
};
